import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "p-10 flex flex-col justify-center items-center h-full" };
var _hoisted_2 = { class: "mt-5 font-bold text-dark/20" };
var _hoisted_3 = { class: "text-sm text-dark/80 font-bold ml-2" };
import EIcon from '@common/ui/EIcon.vue';
import EButton from '@common/ui/EButton.vue';
import ECircleMark from '@common/ui/ECircleMark/ECircleMark.vue';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EmptyNotifications',
    emits: ["showReaded"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var t = useI18n().t;
        var emit = __emit;
        var isHovering = ref(false);
        var toggleHover = function () {
            isHovering.value = !isHovering.value;
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(EIcon, {
                    class: "text-dark/20 w-14 h-14",
                    icon: "notifications/bell-with-circle"
                }),
                _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('notification.noNewNotifications')), 1),
                _createVNode(EButton, {
                    class: "mt-7 h-10",
                    size: "medium",
                    type: "secondary",
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (emit('showReaded')); }),
                    onMouseleave: toggleHover,
                    onMouseover: toggleHover
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(ECircleMark, {
                            "is-hovering": isHovering.value,
                            theme: "gray"
                        }, null, 8, ["is-hovering"]),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('notification.showReadNotifications')), 1)
                    ]; }),
                    _: 1
                })
            ]));
        };
    }
});
